export const FETCH_HIRING_TEAMS = 'companyExperience/views/sessions/FETCH_HIRING_TEAMS'
export const FETCH_HIRING_TEAMS_SUCCESS = 'companyExperience/views/sessions/FETCH_HIRING_TEAMS_SUCCESS'
export const FETCH_HIRING_TEAMS_ERROR = 'companyExperience/views/sessions/FETCH_HIRING_TEAMS_ERROR'

export const FETCH_METADATA = 'companyExperience/views/sessions/FETCH_METADATA'
export const FETCH_METADATA_SUCCESS = 'companyExperience/views/sessions/FETCH_METADATA_SUCCESS'
export const FETCH_METADATA_ERROR = 'companyExperience/views/sessions/FETCH_METADATA_ERROR'

export const FETCH_COMPANY_ACCOUNT = 'companyExperience/views/sessions/FETCH_COMPANY_ACCOUNT'
export const FETCH_COMPANY_ACCOUNT_SUCCESS = 'companyExperience/views/sessions/FETCH_COMPANY_ACCOUNT_SUCCESS'
export const FETCH_COMPANY_ACCOUNT_ERROR = 'companyExperience/views/sessions/FETCH_COMPANY_ACCOUNT_ERROR'

export const SWITCH_HIRING_TEAM = 'companyExperience/views/sessions/SWITCH_HIRING_TEAM'
export const SIGN_OUT = 'companyExperience/views/sessions/SIGN_OUT'

export const fetchHiringTeams = () => ({
  type: FETCH_HIRING_TEAMS,
  payload: {
    fetchingHiringTeams: true,
    fetchHiringTeamsError: null,
  },
})

export const fetchHiringTeamsSuccess = ({ result }) => ({
  type: FETCH_HIRING_TEAMS_SUCCESS,
  payload: {
    fetchingHiringTeams: false,
    lastUpdatedHiringTeams: Date.now(),
    hiringTeams: result.map(team => team.id),
  },
})

export const fetchHiringTeamError = errorMessage => ({
  type: FETCH_HIRING_TEAMS_ERROR,
  error: true,
  payload: new Error(errorMessage),
})

export const fetchMetadata = () => ({
  type: FETCH_METADATA,
  payload: {
    fetchingMetadata: true,
    fetchMetadataError: null,
  },
})

export const fetchMetadataSuccess = ({ result }) => ({
  type: FETCH_METADATA_SUCCESS,
  payload: {
    fetchingMetadata: false,
    lastUpdatedMetadata: Date.now(),
    companyState: result.company_state,
    greenHouseIntegration: result.greenhouse_integration,
    unreadInterviewRequestCount: result.total_unread_interview_requests,
  },
})

export const fetchMetadataError = errorMessage => ({
  type: FETCH_METADATA_ERROR,
  error: true,
  payload: new Error(errorMessage),
})

export const fetchCompanyAccount = companySlug => ({
  type: FETCH_COMPANY_ACCOUNT,
  meta: { companySlug },
  payload: {
    fetchingCompanyAccount: true,
    fetchCompanyAccountError: null,
  },
})

export const fetchCompanyAccountSuccess = ({ result }) => ({
  type: FETCH_COMPANY_ACCOUNT_SUCCESS,
  payload: {
    fetchingCompanyAccount: false,
    lastUpdatedCompanyAccount: Date.now(),
    companyId: result.id,
  },
})

export const fetchCompanyAccountError = errorMessage => ({
  type: FETCH_COMPANY_ACCOUNT_ERROR,
  error: true,
  payload: new Error(errorMessage),
})

export const switchHiringTeam = (companySlug, data) => ({
  type: SWITCH_HIRING_TEAM,
  meta: { companySlug, data },
})

export const signOut = () => ({
  type: SIGN_OUT,
})

const defaultView = {
  hiringTeams: [],
  fetchingHiringTeams: false,
  fetchHiringTeamsError: null,
  lastUpdatedHiringTeams: null,

  companyId: null,
  fetchingCompanyAccount: false,
  fetchCompanyAccountError: null,
  lastUpdatedCompanyAccount: null,

  companyState: null,
  greenHouseIntegration: false,
  unreadInterviewRequestCount: 0,
  fetchingMetadata: false,
  fetchMetadataError: null,
  lastUpdatedMetadata: null,
}

const view = (state = defaultView, { type, payload }) => {
  switch (type) {
    case FETCH_HIRING_TEAMS:
    case FETCH_HIRING_TEAMS_SUCCESS:
    case FETCH_METADATA:
    case FETCH_METADATA_SUCCESS:
    case FETCH_COMPANY_ACCOUNT:
    case FETCH_COMPANY_ACCOUNT_SUCCESS:
      return { ...state, ...payload }

    case FETCH_HIRING_TEAMS_ERROR:
      return { ...state, fetchingHiringTeams: false, fetchHiringTeamsError: payload }

    case FETCH_METADATA_ERROR:
      return { ...state, fetchingMetadata: false, fetchMetadataError: payload }

    case FETCH_COMPANY_ACCOUNT_ERROR:
      return { ...state, fetchingCompanyAccount: false, fetchCompanyAccountError: payload }

    default:
      return state
  }
}

export default view

export const getSessionView = state => state.views.sessions || defaultView
